import type { MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";
import { sfx } from "@/lib/sfx";

// Place explicitly in the existing header. Internal steps may keep their own back handler.
export default function MirrorBackButton({ className = "", disabled = false, onClick }: {
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}) {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return <button type="button" aria-label={t("common.back")} disabled={disabled}
    onClick={onClick ?? (() => { sfx.navigate("module"); navigate("/mirror"); })}
    className={"relative z-10 inline-flex min-h-11 min-w-11 shrink-0 self-start items-center justify-center rounded-xl p-2 -ml-2 text-foreground/80 hover:bg-foreground/[0.06] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40 " + className}>
    <ChevronLeft size={22} aria-hidden="true" />
  </button>;
}
